// middleware/301redirects.js
const INSTANCE_URL = process.env.INSTANCE_URL || "https://www.moominarabia.com";

export default function ({ req, redirect, i18n, $cookies }) {
  if (!process.server) return;
  const curLocale = i18n.localeProperties.code || "fi-fi";
  const NEW_WEBSHOP_PATH = `/${curLocale}/new-webshop`;

    const redirects = {
    // "/en/cart": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/blogs/news": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/evastekaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/kayttoehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/myyntiehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/raffle-credit-card-reservation-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/raffle-shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/textiles": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/textiles-teaser": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/the-moomin-sea-breeze-mug-faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/the-moomin-sea-breeze-platinum-edition-mug-faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/tietosuojakaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/winter-seasonals": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/pages/moomin-arabia-sea-breeze-mug-terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/cart": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/evastekaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/kayttoehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/myyntiehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/the-moomin-sea-breeze-platinum-edition-mug-faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/raffle-shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/raffle-summary": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/textiles": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/textiles-teaser": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/thank-you-for-subscribing": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/the-moomin-sea-breeze-mug-faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/tietosuojakaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/pages/winter-seasonals": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/cart": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/evastekaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/kayttoehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/myyntiehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/raffle-terms": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/textiles": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/textiles-teaser": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/the-moomin-sea-breeze-platinum-edition-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/tietosuojakaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/pages/winter-seasonals": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-no/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/cart": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/evastekaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/kayttoehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/myyntiehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/raffle-summary": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/textiles": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/textiles-teaser": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/tietosuojakaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/pages/winter-seasonals": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/cart": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/https://fiskarsgroup.com/privacy-policy-no": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/evastekaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/kayttoehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/moomin-arabia-sea-breeze-mug-terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/myyntiehdot": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/orders-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/raffle-credit-card-reservation-payments": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/raffle-rules": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/raffle-shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/raffle-summary": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/raffle-terms": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/shipping-deliveries": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/terms-of-sale": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/textiles": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/textiles-teaser": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/the-moomin-sea-breeze-mug-faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/the-moomin-sea-breeze-platinum-edition-mug-faq": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/the-moomin-sea-breeze-platinum-edition-mug-returns-refunds": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/tietosuojakaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/winter-seasonals": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/pages/shop": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/shop": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/no-no/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/sv-se/cart": `${INSTANCE_URL}/sv-se/varukorg`,
    "/sv-se/pages/evastekaytanto": `${INSTANCE_URL}/sv-se/cookie-policy`,
    "/sv-se/pages/faq": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/kayttoehdot": `${INSTANCE_URL}/sv-se/webbplatsvillkor`,
    "/sv-se/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/moomin-arabia-sea-breeze-mug-terms-of-sale": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/myyntiehdot": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv-se/pages/orders-payments": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/raffle-rules": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/raffle-shipping-deliveries": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/raffle-summary": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/raffle-terms": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/returns-refunds": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/shipping-deliveries": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/terms-of-sale": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv-se/pages/textiles": `${INSTANCE_URL}/sv-se/textilier`,
    "/sv-se/pages/textiles-teaser": `${INSTANCE_URL}/sv-se/textilier`,
    "/sv-se/pages/the-moomin-sea-breeze-mug-faq": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/the-moomin-sea-breeze-platinum-edition-mug-faq": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/the-moomin-sea-breeze-platinum-edition-mug-returns-refunds": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv-se/pages/tietosuojakaytanto": `https://fiskarsgroup.com/sv/fiskars-groups-integritetspolicyer/integritetspolicy-for-konsumenter/`,
    "/sv-se/pages/winter-seasonals": `${INSTANCE_URL}/sv-se/upptack/kollektioner/vinterkollektionen`,
    "/sv-se/pages/shop": `${INSTANCE_URL}/sv-se/`,
    "/sv-se/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}/sv-se/upptack/kollektioner/limited-edition`,
    "/sv-se/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}/sv-se/upptack/kollektioner/limited-edition`,
    "/sv-se/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}/sv-se/upptack/kollektioner/limited-edition`,
    "/sv/cart": `${INSTANCE_URL}/sv-se/varukorg`,
    "/sv/pages/evastekaytanto": `${INSTANCE_URL}/sv-se/cookie-policy`,
    "/sv/pages/faq": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/kayttoehdot": `${INSTANCE_URL}/sv-se/webbplatsvillkor`,
    "/sv/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/moomin-arabia-sea-breeze-mug-terms-of-sale": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/myyntiehdot": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/orders-payments": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/raffle-rules": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/raffle-shipping-deliveries": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/raffle-summary": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/raffle-terms": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/returns-refunds": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/shipping-deliveries": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/terms-of-sale": `${INSTANCE_URL}/sv-se/forsaljningsvillkor`,
    "/sv/pages/textiles": `${INSTANCE_URL}/sv-se/textilier`,
    "/sv/pages/textiles-teaser": `${INSTANCE_URL}/sv-se/textilier`,
    "/sv/pages/the-moomin-sea-breeze-mug-faq": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/the-moomin-sea-breeze-platinum-edition-mug-faq": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/the-moomin-sea-breeze-platinum-edition-mug-returns-refunds": `${INSTANCE_URL}/sv-se/vanliga-fragor`,
    "/sv/pages/tietosuojakaytanto": `https://fiskarsgroup.com/sv/fiskars-groups-integritetspolicyer/integritetspolicy-for-konsumenter/`,
    "/sv/pages/winter-seasonals": `${INSTANCE_URL}/sv-se/upptack/kollektioner/vinterkollektionen`,
    "/sv/pages/shop": `${INSTANCE_URL}/sv-se/`,
    "/pages/evastekaytanto": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/pages/faq": `${INSTANCE_URL}/${curLocale}/`,
    "/pages/kayttoehdot": `${INSTANCE_URL}/${curLocale}/ukk`,
    "/pages/moomin-arabia-sea-breeze-mug-returns-refunds": `${INSTANCE_URL}/${curLocale}/kayttoehdot`,
    "/pages/moomin-arabia-sea-breeze-mug-terms-of-sale": `${INSTANCE_URL}/${curLocale}/ukk#Palautuksetjahyvitykset`,
    "/pages/moomin-sea-breeze-mug-orders-payments": `${INSTANCE_URL}/${curLocale}/myyntiehdot`,
    "/pages/myyntiehdot": `${INSTANCE_URL}/${curLocale}/ukk#Tilaaminenjamaksaminen`,
    "/pages/orders-payments": `${INSTANCE_URL}/${curLocale}/myyntiehdot`,
    "/pages/raffle-credit-card-reservation-payments": `${INSTANCE_URL}/${curLocale}/ukk#Tilaaminenjamaksaminen`,
    "/pages/raffle-rules": `${INSTANCE_URL}/${curLocale}/`,
    "/pages/raffle-shipping-deliveries": `${INSTANCE_URL}/${curLocale}/`,
    "/pages/raffle-summary": `${INSTANCE_URL}/${curLocale}/`,
    "/pages/raffle-terms": `${INSTANCE_URL}/${curLocale}/`,
    "/pages/returns-refunds": `${INSTANCE_URL}/${curLocale}/`,
    "/pages/shipping-deliveries": `${INSTANCE_URL}/${curLocale}/ukk#Palautuksetjahyvitykset`,
    "/pages/terms-of-sale": `${INSTANCE_URL}/${curLocale}/ukk#Lähettäminenjatoimitukset`,
    "/pages/textiles": `${INSTANCE_URL}/${curLocale}/myyntiehdot`,
    "/pages/textiles-teaser": `${INSTANCE_URL}/${curLocale}/tekstiilit`,
    "/pages/the-moomin-sea-breeze-mug-faq": `${INSTANCE_URL}/${curLocale}/tekstiilit`,
    "/pages/the-moomin-sea-breeze-platinum-edition-mug-faq": `${INSTANCE_URL}/${curLocale}/ukk`,
    "/pages/tietosuojakaytanto": `${INSTANCE_URL}/${curLocale}/ukk`,
    "/pages/winter-seasonals":
      "https://fiskarsgroup.com/fi/fiskars-groupin-tietosuojakaytannot/tietosuojakaytanto-kuluttajille",
    "/products/moomin-mug-0-3l-journey": `${INSTANCE_URL}/${curLocale}/kokoelmat-ja-inspiraatio/kokoelmat/talvikokoelma`,
    "/products/sea-breeze-moomin-s-day-edition": `${INSTANCE_URL}/${curLocale}/kokoelmat-ja-inspiraatio/kokoelmat/erikoiserat`,
    "/products/sea-breeze-platinum-edition-raffle": `${INSTANCE_URL}/${curLocale}/`,
    "/search": `${INSTANCE_URL}/${curLocale}/`,
    "/shop": `${INSTANCE_URL}/${curLocale}/`,
    "/blogs/news": `${INSTANCE_URL}/${curLocale}/`,
    // "/no-no": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    // "/no-no/*": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-se": `${INSTANCE_URL}/sv-se/`,
    "/en-se/*": `${INSTANCE_URL}/sv-se/`,
    "/en-no": `${INSTANCE_URL}/no-no/`,
    "/en-no/*": `${INSTANCE_URL}/no-no/`,
    // "/en": `${INSTANCE_URL}/${curLocale}/`,
    // "/en/*": `${INSTANCE_URL}/${curLocale}/`,
    "/pages": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/pages/*": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/en-eu/*": `${INSTANCE_URL}${NEW_WEBSHOP_PATH}`,
    "/cart": `${INSTANCE_URL}/${curLocale}/`,
  };

const foundRedirect = Object.entries(redirects).find(([pattern, redirection]) => {
  const regex = new RegExp(
      `^${pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\/|$)`
    );
    // const regex = new RegExp(`^${pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\/|$)`);
  return regex.test(req.url);
});
  
  
  
  
  if (foundRedirect) {
   $cookies.set("301redirected", true, {
      maxAge: 10, // 2 minutes in seconds
      path: "/",
    });
    const [, redirection] = foundRedirect;
    console.log("301 redirecting to:", redirection);
    redirect(redirection);
  }
}